module.exports = "/_next/static/images/chat-line-1a328877f6f5f923d333c089c61d2368.svg";